import React from "react";
// import superagent from 'superagent';
// import Signup from './signup';
import {inject, observer} from "mobx-react";
import "../../styles/login.css";
// import PropTypes from 'prop-types';
import Modal from "react-bulma-components/lib/components/modal";
// import Image from 'react-bulma-components/lib/components/image';
import Button from "react-bulma-components/lib/components/button";
import Section from "react-bulma-components/lib/components/section";
// let _login = false
import {withRouter} from "react-router-dom";
// import { validateIfInputHasSpaces } from '../../../../helpers/validationChecks'
// import UserStore from '../../stores/userStore';
// import LandingPage from './landingPage';
// import SocialButton from './socialLogin'
// const imagesPath = {
//     unchecked: require('../../../assets/unchecked.png'),
//     checked: require('../../../assets/checked.png')
// }

@inject('authStore', 'userStore', 'navigatorStore')
@withRouter
@observer
export default class changePWD extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            password: "",
            cpassword: ""
        }
    }
    onValuChangedText(event) {
        this.setState({
            [event.target.name]: event.target.value
        })
    }

    close(e, info) {
        // e.preventDefault();
        this.props.navigatorStore.closeErrorModal();
        this.props.navigatorStore.isInfo ? this.props.handleActions(info, this.props.navigatorStore.information) : ""
        return;
    }
    render() {
        return (
            // <Modal show={true} onClose={this.close.bind(this)}
            <Modal show={this.props.navigatorStore.errorModal} onClose={this.close.bind(this)}
                className="error-modal-layout"
            >
                {/* {this.props.children} */}
                <Modal.Content>
                    <Section style={{ backgroundColor: 'white', padding: "none" }} className="mymodal">
                        <form className="myform" >
                            {/* <div style={{ textAlign: "left" }} className="log-in">
                            <div className="ruling-forgot-password-section"></div> */}


                            <p className="error-text pl-25 ml-15 mr-15 mt-25">
                                <img onClick={this.close.bind(this)} className="cross-icon-for-masterpieces-modal" src={require('../../assets/cross_icon_for_close.png')}></img>

                                <div style={{ display: (!this.props.navigatorStore.isInfo && !this.props.navigatorStore.informationNoAction) ? "" : "none" }} className="error-border">
                                    <div className="path-vert">
                                        <div className="path-hr">
                                        </div>
                                    </div>
                                </div>

                                <p className="error-text mr-15">
                                    {String(this.props.navigatorStore.errorMessage)}
                                </p>

                            </p>

                            <div className="remember-me-and-login-section error-btn-block" >

                                <div style={{
                                    flex: "1",

                                }} >
                                    <Button className="button-link-login width-110" onClick={(e) => this.close(e, false)}
                                        style={{ backgroundColor: "#BEA57C", borderRadius: "unset", marginRight: "10px" }} >
                                        {(this.props.navigatorStore.isInfo) ? "NO" : "OKAY"}
                                    </Button>
                                    <Button className="button-link-login width-110" onClick={(e) => this.close(e, true)} style={{
                                        backgroundColor: "#333333",
                                        borderRadius: "unset", marginRight: "10px", display: (this.props.navigatorStore.isInfo) ? "" : "none"
                                    }} >YES
                                    </Button>
                                </div>

                            </div>


                        </form>
                    </Section>
                </Modal.Content>
            </Modal>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/errorHandling/errorModal.js